import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useGroup } from '../context/GroupContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import '../styles/StripeSetupBanner.css';

const StripeSetupBanner = () => {
  const { currentUser } = useAuth();
  const { adminGroup } = useGroup();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user dismissed the banner in this session
    const dismissedInSession = sessionStorage.getItem('stripeSetupBannerDismissed');
    
    // Debug logging
    console.log('🏦 Banner Debug:', {
      hasCurrentUser: !!currentUser,
      isAdmin: currentUser?.role === 'admin',
      hasAdminGroup: !!adminGroup,
      onboardingStatus: adminGroup?.onboarding_status,
      dismissedInSession: dismissedInSession === 'true',
      willShow: currentUser && currentUser.role === 'admin' && adminGroup && adminGroup.onboarding_status !== 'active' && dismissedInSession !== 'true'
    });
    
    // Show banner if:
    // 1. User is logged in as admin
    // 2. Group doesn't have active Stripe onboarding status
    // 3. User hasn't dismissed it in this session
    if (currentUser && 
        currentUser.role === 'admin' && 
        adminGroup && 
        adminGroup.onboarding_status !== 'active' &&
        dismissedInSession !== 'true') {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [currentUser, adminGroup]);

  const handleDismiss = () => {
    setIsVisible(false);
    // Store dismissal in sessionStorage (will clear on page refresh/new tab)
    sessionStorage.setItem('stripeSetupBannerDismissed', 'true');
  };

  const handleSetupClick = () => {
    // Navigate to financials page, payouts tab
    window.location.href = '#/admin/dashboard/financials?tab=payouts';
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="stripe-setup-banner">
      <div className="banner-content">
        <div className="banner-message">
          <span>Please link your payout method to start receiving payments.</span>
          <button 
            className="complete-setup-button"
            onClick={handleSetupClick}
          >
            Complete setup
          </button>
        </div>
        <div className="banner-actions">
          <button 
            className="dismiss-button"
            onClick={handleDismiss}
            aria-label="Dismiss banner"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StripeSetupBanner;